import React from "react";
import { SVGIconProps } from "../type";

export default function Stellar({ className, style }: SVGIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
      viewBox="0 0 1594.44 2000"
    >
      <path
        fill="#ed8117"
        d="M493.91 1475.97c88.88 63.07 251.85-15.57 367.38-175.55 1.63-2.12 3.38-4.1 4.91-6.32 63.55-90.81 41.65-216.36-48.81-280.56s-215.29-42.61-278.75 48.18c-1.56 2.23-2.84 4.55-4.29 6.82-110.69 163.44-129.31 344.42-40.44 407.43"
      ></path>
      <path
        fill="#eebb18"
        d="M584.83 1355c61.86 42.83 176.06-11.68 257.42-121.76 1.19-1.46 2.41-2.82 3.52-4.35a136.31 136.31 0 00-33-192.06c-63-43.66-150.35-28.37-195.08 34.1-1.14 1.54-2 3.13-3 4.67-78.03 112.43-91.76 236.54-29.86 279.4"
      ></path>
      <path
        fill="#5b6a72"
        d="M200.73 835.22c-9.33 12-13.93 30.08 11.42 22.19 72.31-22.49 236.24-48.74 426.52 83.25 257 178.24 236.13-283.74 236.13-283.74-61.03-42.29-368.11-213.95-674.07 178.3m976.97 696.47c1.09 26.11 16.5 15.85 24.58 3.23 264.54-413.42 1.16-641.18-58.88-683.68 0 0-439.1 133.64-186.34 312.76 187.15 132.61 217.48 293.24 220.64 367.69"
      ></path>
      <path
        fill="#dcf2f9"
        d="M910.74 1234.07c50.18 37.1 80.53 43.15 117-1.9s228.27-270 419.89-518 74.73-674.76 51.73-691.76l-.3.36.2-.45c-23-17-445.63 11.29-603.78 284S599.92 844.15 571.77 895.31s-12.51 79.18 37.66 116.25c22.86 16.85 87.23 64.41 150.65 111.25s127.8 94.41 150.66 111.26"
      ></path>
      <path
        fill="#5b6a72"
        d="M967.29 1288.87h-2.08c-22.9-.62-46.78-10.86-79.84-34.26-23.25-16.44-88-62.26-152.57-108l-3.8-2.69-101.58-71.86-54.84-38.8c-33-23.38-50.65-42.49-58.91-63.92-12.93-33.52 1-64.26 12.57-84.47 6.07-10.58 17.18-30.59 32.55-58.28 56.49-101.79 174-313.61 303.89-528.15 46.74-77.21 118.21-142 212.43-192.67 49.8-26.76 133-63.6 246.3-87.15C1366.2 9.31 1412.11 3 1450.68.83c59.12-3.32 69.61 4.12 74.66 7.7l.47.34c5.18 3.69 15.57 12.12 32 67.94 11 37.41 20.55 83.17 26.89 128.85 17.4 125.3 26.51 360.38-107.93 527-157.36 195.12-316.31 377.65-392.7 465.32-20.8 23.89-35.83 41.14-43.7 50.45-11.46 13.55-22.71 23.35-34.4 30a77.62 77.62 0 01-38.68 10.44m511.45-1239c-41.39 0-131.86 8.53-233.89 39.77-110.6 33.83-259.29 102.03-339.49 234.61-129.43 213.73-246.66 425-303 526.52-15.47 27.88-26.65 48-32.9 58.91-13.46 23.46-12 34.62-9.3 41.72 4.35 11.27 17.44 24.35 41.2 41.17l54.85 38.8 101.58 71.86 3.81 2.7c64.57 45.7 129.31 91.51 152.56 108 49 34.67 63.53 31.44 88.15 2.35 8.1-9.58 23.23-27 44.17-51 76.19-87.47 234.72-269.49 391.45-463.83 97.3-120.62 111.14-284.31 105.63-400.39-6-125.74-35.93-225.76-47.89-250.48a164.74 164.74 0 00-16.93-.75"
      ></path>
      <path
        fill="#fefefe"
        d="M1065.47 622.46c80.07 56.44 190.71 37.25 247-42.83s37.19-190.72-42.88-247.16-190.67-37.29-247 42.82-37.16 190.72 42.88 247.17"
      ></path>
      <path
        fill="#5b6a72"
        d="M1167.18 679.9a202.48 202.48 0 01-165-319 202.16 202.16 0 01281.88-48.88c91.23 64.31 113.17 190.82 48.91 282a200.79 200.79 0 01-130.79 82.84 204.73 204.73 0 01-35 3.04m.63-354.86a154 154 0 00-26.35 2.27 151.09 151.09 0 00-98.38 62.36c-48.33 68.68-31.82 163.94 36.81 212.34a152.2 152.2 0 00212.17-36.78c48.39-68.67 31.86-163.91-36.83-212.33a151.2 151.2 0 00-87.42-27.86"
      ></path>
      <path
        fill="#979797"
        d="M.03 1985.48l280.887-395.248 20.386 14.488-280.887 395.248zm161.04-50.382l164.315-232.306 20.508 14.506-164.314 232.306z"
      ></path>
    </svg>
  );
}
